module.exports = __webpack_public_path__ + "static/media/spin.361c7d2b.svg";